import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import TranslationContainer from '../../../translation/translation_container';
import getTranslatedText from '../../../../helper/get_translated_text';
import { Filters } from '../../../../constants/filter/filters';
import {FilterLabelTranslationKeys} from "../../../../constants/filter/filter_label_translation_keys";
import Translation from '../../../translation/translation';

function CustomerReviews(props) {
    const opened = props.opened
        || !!props.customerReviewDryTractionRatingAvgGroupValue || !!props.customerReviewLowNoiseRatingAvgGroupValue
        || !!props.customerReviewRideComfortRatingAvgGroupValue || !!props.customerReviewSteeringResponseAvgGroupValue
        || !!props.customerReviewTreadWearAvgGroupValue || !!props.customerReviewValueForMoneyAvgGroupValue
        || !!props.customerReviewWetTractionRatingAvgGroupValue;

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-customer-reviews'
            containerModifier="tyre-ratings"
            extraHeight={true}
        >
            <TranslationContainer
                targetProperties={{tooltipContent: { translationKey: 'catalog-filter-customer-review-dry-traction-rating-tooltip-text' },}}
            >
            <FilterSelect
                name={Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP}
                value={props.customerReviewDryTractionRatingAvgGroupValue}
                options={props.customerReviewDryTractionRatingAvgGroupOptions}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]}
                provideAllTranslationKey="catalog-filters-customer-review-dry-traction-rating-select-label-all"
                onChange={props.onCustomerReviewDryTractionRatingAvgGroupChange}
                onToolTipHover={() => props.onToolTipHover('Dry traction rating')}
                provideAllOption={true}
                tooltipContent="There should be some text here"
                highlight={!props.customerReviewDryTractionRatingAvgGroupValue}
                unavailableOptions = {[]}
                />
            </TranslationContainer>
            <TranslationContainer
                targetProperties={{tooltipContent: { translationKey: 'catalog-filter-customer-review-low-noise-rating-tooltip-text' },}}
            >
            <FilterSelect
                name={Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP}
                value={props.customerReviewLowNoiseRatingAvgGroupValue}
                options={props.customerReviewLowNoiseRatingAvgGroupOptions}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]}
                provideAllTranslationKey="catalog-filters-customer-review-low-noise-rating-select-label-all"
                onChange={props.onCustomerReviewLowNoiseRatingAvgGroupChange}
                onToolTipHover={() => props.onToolTipHover('Low noise rating')}
                provideAllOption={true}
                tooltipContent="There should be some text here"
                highlight={!props.customerReviewLowNoiseRatingAvgGroupValue}
                unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{tooltipContent: { translationKey: 'catalog-filter-customer-review-ride-comfort-rating-tooltip-text' },}}
            >
            <FilterSelect
                name={Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP}
                value={props.customerReviewRideComfortRatingAvgGroupValue}
                options={props.customerReviewRideComfortRatingAvgGroupOptions}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]}
                provideAllTranslationKey="catalog-filters-customer-review-ride-comfort-rating-select-label-all"
                onChange={props.onCustomerReviewRideComfortRatingAvgGroupChange}
                onToolTipHover={() => props.onToolTipHover('Ride comfort rating')}
                provideAllOption={true}
                tooltipContent="There should be some text here"
                highlight={!props.customerReviewRideComfortRatingAvgGroupValue}
                unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{tooltipContent: { translationKey: 'catalog-filter-customer-review-steering-response-rating-tooltip-text' },}}
            >
            <FilterSelect
                name={Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP}
                value={props.customerReviewSteeringResponseAvgGroupValue}
                options={props.customerReviewSteeringResponseAvgGroupOptions}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]}
                provideAllTranslationKey="catalog-filters-customer-review-steering-response-rating-select-label-all"
                onChange={props.onCustomerReviewSteeringResponseAvgGroupChange}
                onToolTipHover={() => props.onToolTipHover('Steering response rating')}
                provideAllOption={true}
                tooltipContent="There should be some text here"
                highlight={!props.customerReviewSteeringResponseAvgGroupValue}
                unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{tooltipContent: { translationKey: 'catalog-filter-customer-review-tread-wear-rating-tooltip-text' },}}
            >
            <FilterSelect
                name={Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP}
                value={props.customerReviewTreadWearAvgGroupValue}
                options={props.customerReviewTreadWearAvgGroupOptions}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]}
                provideAllTranslationKey="catalog-filters-customer-review-tread-wear-rating-select-label-all"
                onChange={props.onCustomerReviewTreadWearAvgGroupChange}
                onToolTipHover={() => props.onToolTipHover('Tread wear rating')}
                provideAllOption={true}
                tooltipContent="There should be some text here"
                highlight={!props.customerReviewTreadWearAvgGroupValue}
                unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{tooltipContent: { translationKey: 'catalog-filter-customer-review-value-for-money-rating-tooltip-text' },}}
            >
            <FilterSelect
                name={Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP}
                value={props.customerReviewValueForMoneyAvgGroupValue}
                options={props.customerReviewValueForMoneyAvgGroupOptions}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]}
                provideAllTranslationKey="catalog-filters-customer-review-value-for-money-rating-select-label-all"
                onChange={props.onCustomerReviewValueForMoneyAvgGroupChange}
                onToolTipHover={() => props.onToolTipHover('Value for money rating')}
                provideAllOption={true}
                tooltipContent="There should be some text here"
                highlight={!props.customerReviewValueForMoneyAvgGroupValue}
                unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{tooltipContent: { translationKey: 'catalog-filter-customer-review-wet-traction-rating-tooltip-text' },}}
            >
            <FilterSelect
                name={Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP}
                value={props.customerReviewWetTractionRatingAvgGroupValue}
                options={props.customerReviewWetTractionRatingAvgGroupOptions}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]}
                provideAllTranslationKey="catalog-filters-customer-review-wet-traction-rating-select-label-all"
                onChange={props.onCustomerReviewWetTractionRatingAvgGroupChange}
                onToolTipHover={() => props.onToolTipHover('Wet traction rating')}
                provideAllOption={true}
                tooltipContent="There should be some text here"
                highlight={!props.customerReviewWetTractionRatingAvgGroupValue}
                unavailableOptions = {[]}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

CustomerReviews.propTypes = {
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,

    customerReviewDryTractionRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewDryTractionRatingAvgGroupOptions: PropTypes.array.isRequired,
    onCustomerReviewDryTractionRatingAvgGroupChange: PropTypes.func.isRequired,

    customerReviewLowNoiseRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewLowNoiseRatingAvgGroupOptions: PropTypes.array.isRequired,
    onCustomerReviewLowNoiseRatingAvgGroupChange: PropTypes.func.isRequired,

    customerReviewRideComfortRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewRideComfortRatingAvgGroupOptions: PropTypes.array.isRequired,
    onCustomerReviewRideComfortRatingAvgGroupChange: PropTypes.func.isRequired,

    customerReviewSteeringResponseAvgGroupValue: PropTypes.string.isRequired,
    customerReviewSteeringResponseAvgGroupOptions: PropTypes.array.isRequired,
    onCustomerReviewSteeringResponseAvgGroupChange: PropTypes.func.isRequired,

    customerReviewTreadWearAvgGroupValue: PropTypes.string.isRequired,
    customerReviewTreadWearAvgGroupOptions: PropTypes.array.isRequired,
    onCustomerReviewTreadWearAvgGroupChange: PropTypes.func.isRequired,

    customerReviewValueForMoneyAvgGroupValue: PropTypes.string.isRequired,
    customerReviewValueForMoneyAvgGroupOptions: PropTypes.array.isRequired,
    onCustomerReviewValueForMoneyAvgGroupChange: PropTypes.func.isRequired,

    customerReviewWetTractionRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewWetTractionRatingAvgGroupOptions: PropTypes.array.isRequired,
    onCustomerReviewWetTractionRatingAvgGroupChange: PropTypes.func.isRequired,
};

export { CustomerReviews };
